import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { BaseClickable, palette, Stack, Text } from '@solvhealth/jigsaw-v1';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { AccountManageTabs } from '../../../../../../components/AccountGetsMarried/constants/AccountViews';
import { colors } from '../../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import history from '../../../../../../core/history';
import { biggerThanOrEqualTo } from '../../../../../../core/util/styledComponents';
import useToggleRuntimeVariable from '../../../../../../hooks/runtime/useToggleRuntimeVariable';
import SimpleTabs, { SolvStyledTab } from '../../../../../SolvPatternLibrary/SimpleTabs';

const VisitTabs = styled.div.withConfig({ componentId: 'sc-18p0cmq-0' })`
  position: sticky;
  top: 0;
  height: 40px;
  width: 100%;
  z-index: 1;
  background-color: ${colors.marriedToPurple};

  ${biggerThanOrEqualTo.sm`
    top: 40px;
  `}

  .tab-root {
    background-color: ${colors.marriedToPurple};
  }
`;

const navigateHome = (userProfileId: any) =>
  history.push(`/account/home/${userProfileId}/get-care`);

type HeaderProps = {
  userProfileId: string;
  firstName: string;
  setTabIndex: (...args: any[]) => any;
  tabIndex: number;
};

const Header = (props: HeaderProps) => {
  const { userProfileId, firstName, tabIndex, setTabIndex } = props;
  const [, toggleAccountDrawer] = useToggleRuntimeVariable('account-drawer');

  const { t } = useTranslation(['account']);

  return (
    <>
      <VisitTabs>
        <SimpleTabs
          className="tab-root"
          onChange={((_: any, value: any) => setTabIndex(value)) as any}
          value={tabIndex}
          variant="fullWidth"
        >
          <SolvStyledTab
            activeTextColor={palette.grape.dark}
            defaultTextColor={palette.grape.dark}
            label={t('account:manage.tabs.upcoming')}
            value={AccountManageTabs.Upcoming}
          />

          <SolvStyledTab
            activeTextColor={palette.grape.dark}
            defaultTextColor={palette.grape.dark}
            label={t('account:manage.tabs.past')}
            value={AccountManageTabs.Past}
          />
        </SimpleTabs>
      </VisitTabs>
    </>
  );
};

export default Header;
